import { useState, useEffect } from 'react'

import { isBrowser } from 'helpers'

function addToHistory (key, value, path) {
  if (isBrowser()) {
    const state = window.history.state || {}
    window.history.replaceState({ ...state, [key]: value }, '', path)
  }
}

// reference: https://gal.hagever.com/posts/react-forms-and-history-state
export default function useHistoryState (key, initialValue) {
  const [rawState, rawSetState] = useState(initialValue)

  useEffect(() => {
    if (isBrowser()) {
      const value = window.history.state?.[key] ?? initialValue
      rawSetState(value)
    }
  }, [])

  function setState (value, path) {
    addToHistory(key, value, path)
    rawSetState(value)
  }
  return [rawState, setState]
}
